import React from "react";
import ReactDOM from "react-dom";
import "./vendor/normalize.css";
import "./index.css";
import Main from "./components/Routes/Main.js";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
